import { MasonryPage } from 'components/masonry-page/masonry-page.component';
import { MASONRY } from 'common/constants';

// Full "Suggested for you" list behind the Journey landing's View all
// (GEIS-2499). The tree carries its own web page header, so nothing here is
// conditional.
//
// STR_SUGGESTED_FOR_YOU must stay byte-identical to the tree's heading (the
// `journeySuggestedActivities` Contentful title): the root's `setTitle` writes
// document.title after this hook does, so a mismatch shows as a retitle.
export const SuggestedActivitiesPage = () => (
  <MasonryPage
    screenName="Suggested Activities"
    titleMessageId="STR_SUGGESTED_FOR_YOU"
    rootNodeId={MASONRY.ROOT_NODE_ID_SUGGESTED_ACTIVITIES}
  />
);
